/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordsWithLinks } from "./RecordsWithLinks";
import { RecordCounts } from "./RecordCounts";
import { VersionId } from "../../commons/types/VersionId";
import { CommitId } from "../../commons/types/CommitId";
import { SuccessData } from "../../commons/types/SuccessData";
export const RecordsResponseData = core.serialization
    .object({
    records: RecordsWithLinks.optional(),
    counts: RecordCounts.optional(),
    versionId: VersionId.optional(),
    commitId: CommitId.optional(),
})
    .extend(SuccessData);
